<template>
    <div class="modal-window mbs010 mbs024">
        <header class="modal-header">
            <div class="tit" v-if="$i18nUtil.getLanguage() === 'ko'">{{ $i18nUtil.trans("title.MainExpireExtension.001","이용약관/개인정보 취급방침") }}</div>
            <div class="tit" v-if="$i18nUtil.getLanguage() !== 'ko'">{{ $i18nUtil.trans("title.MainExpireExtension.002","이용약관") }}</div>
            <button @click="$emit('close')" class="btn_close">닫기</button>
        </header>
        
        <div class="modal-content">
            <div class="info-txt">{{ $i18nUtil.trans("message.MainExpireExtension.001","‘{userName}’ 님의 업무공유시스템 계정이 {year}년 {month}월 {day}일 만료됩니다.", {userName: userName, year: year, month: month, day: day}) }}</div>
            <div class="info-txt smaller" v-html="$i18nUtil.trans('message.MainExpireExtension.002','연장이 필요할 경우, 이용약관/개인정보 취급방침에 동의 후 연장을 요청해 주세요.<br>연장되지 않은 계정은 사용 만료일 이후 업무공유시스템 접속이 차단됩니다.')"></div>
            <div class="tab_ty2" id="tabsTy1">
                <ul class="tab-menu" :class="{enCss: $i18nUtil.getLanguage() === 'en'}">
                    <li v-for="(tab, index) in tabsTy1" :key="index" v-bind:class="{active:currentTab1===index}">
                        <button type="button" v-on:click="currentTab1 = index">{{tab}}</button>
                    </li>
                </ul>
                <div class="tab-content">
                    <UseTerms v-show="currentTab1 == 0"/>
                    <PrivacyPolicy v-show="currentTab1 == 1"/>
                </div>
            </div>
            <input type="checkbox" id="agree" v-model="isAgree">
                <label for="agree" v-if="$i18nUtil.getLanguage() === 'ko'">{{ $i18nUtil.trans("message.MainExpireExtension.003","이용약관/개인정보 취급방침에 동의합니다.") }}</label>
                <label for="agree" v-if="$i18nUtil.getLanguage() !== 'ko'">{{ $i18nUtil.trans("message.MainExpireExtension.005","이용약관에 동의합니다.") }}</label>
        </div>

        <footer class="modal-footer">
            <button type="button" class="btn_ty1" @click="handleExtension">{{ $i18nUtil.trans("button.handleExtension","+ 90일 연장 요청") }}</button>
            <div class="txtr">
                <input type="checkbox" id="today" @change="handleExtensionModal"><label for="today">{{ $i18nUtil.trans("message.MainExpireExtension.004","15일간 이 창을 열지 않음") }}</label>
                <button @click="$emit('close')" class="btn_close">닫기</button>
            </div>
        </footer>
        <modals-container @dialogConfirm="dialogConfirm" @dialogSubConfirm="dialogSubConfirm"/>
    </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import UseTerms from "@/components/cowork/join/modal/UseTerms";
import Dialog from "@/components/cowork/common/alertMessage/Dialog";
import PrivacyPolicy from "@/components/cowork/join/modal/PrivacyPolicy";
export default {
    components: {
        UseTerms,
        PrivacyPolicy,
    },
    data() {
        return { 
            userName : null,
            expDate : null,
            year : null,
            month : null,
            day : null,
            isAgree : false,
            currentTab1: 0,
            tabsTy1: [],
            toastInfo: {
                obj: this.$toasted,
                message: "",
                options: {
                    theme: "toasted-primary",
                    position: "bottom-left",
                    duration: 5000,
                    action : {
                        text : 'x',
                        onClick : (e, toastObject) => {
                            toastObject.goAway(0);
                        }
                    }
                },
            },
        };
    },
    mounted() {
        if(this.$i18nUtil.getLanguage() === 'ko') {
            let tab = [ this.$i18nUtil.trans("title.UseTerms.001","이용약관"), this.$i18nUtil.trans("title.PrivacyPolicy.001","개인정보 취급방침") ]
            this.tabsTy1 = tab;
        }else{
            let tab = [ this.$i18nUtil.trans("title.UseTerms.001","이용약관") ]
            this.tabsTy1 = tab;
        }
        this.getExpireUserInfo();
    },
    methods: {
        ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
        ...mapActions("modals", ["showModal", "showToast", "showDialog"]),
        /* 연장 대상자 정보 조회 */
        getExpireUserInfo() {
            let obj = this;
            let reqData = {
                url : "/api/auth/org/getExpiringUserInfo",
                method : "post",
                params: {},
            };
            obj
            .COWORK_REST_SIMPLE_ACTION(reqData)
            .then(function (res) {
                if(res.errorCode !== null) {

                } else {
                    if(res.result !== null) {
                        obj.userName = res.result.userName;
                        let date = new Date(res.result.expDate);
                        obj.year = date.getFullYear();
                        obj.month = date.getMonth() + 1;
                        obj.day = date.getDate();
                    }
                }
            })
            .catch(function(err) {
                console.log(err);
            })
        },
        /* 기간 연장 신청 */
        handleExtension() {
            let obj = this;
            if(obj.isAgree) {
                let info = {
                    title: obj.$i18nUtil.trans("title.dialog.notice","알림"),
                    subButton : obj.$i18nUtil.trans("button.dialog.cancel","취소"),
                    button : obj.$i18nUtil.trans("button.dialog.request","요청"),
                    contents : obj.$i18nUtil.trans("AG066"),
                };
                obj.handleDialog(info);
            } else {
                let msg = obj.$i18nUtil.getLanguage() === 'ko'
                            ? obj.$i18nUtil.trans("AG062", "이용약관/개인정보 취급방침에 동의하셔야 계정 사용 연장이 가능합니다.")
                            : obj.$i18nUtil.trans("AG062.001", "이용약관에 동의하셔야 계정 사용 연장이 가능합니다.")
                let info = {
                    title: obj.$i18nUtil.trans("title.dialog.notice","알림"),
                    button : obj.$i18nUtil.trans("button.dialog.confirm","확인"),
                    contents : msg,
                };
                obj.handleDialog(info);
            }
        },
        dialogConfirm(param) {
            this.requestExtension();
        },
        dialogSubConfirm(param) {
            console.log(param);
        },
        /* 계정 연장 신청 메일 발송 */
        requestExtension() {
            let obj = this;
            let reqData = {
                url : "/api/cogroup/cogroupUser/updateExpDate",
                method : "post",
                params: {},
            };
            obj
            .COWORK_REST_SIMPLE_ACTION(reqData)
            .then(function (res) {
                if(res.errorCode !== null) {
                    console.log(res.errorCode);
                } else {
                    obj.toastInfo.message = obj.$i18nUtil.trans("TB086");
                    obj.showToast(obj.toastInfo);
                }
            })
            .catch(function(err) {
                console.log(err);
            })
        },
        handleExtensionModal() {
            let obj = this;
            let reqData = {
                url : "/api/auth/org/handleExtensionModal",
                method : "post",
                params: {},
            };
            obj
            .COWORK_REST_SIMPLE_ACTION(reqData)
            .then(function (res) {
                if(res.errorCode !== null) {
                    console.log(res.errorCode);
                } else {
                    obj.$emit('close');
                }
            })
            .catch(function(err) {
                console.log(err);
            })
        },
        /* 알림 Dialog */
        handleDialog(info) {
            const dialogInfo = {
                obj: this.$modal,
                component: Dialog,
                title : info.title,
                button : info.button,
                subButton : info.subButton,
                contents : info.contents
            };
            this.showDialog(dialogInfo);
        },
    },
}
</script>

<style scoped>
    .tab_ty2 > .enCss li button {
        padding: 0;
    }
</style>


// WEBPACK FOOTER //
// src/components/cowork/general/main/modal/MainExpireExtension.vue